import { createRouter, createWebHashHistory } from 'vue-router'

import HomeView from '../views/home-view.vue'
import StatusesView from '../views/statuses-view.vue'
import ExcCountsView from '../views/exccounts-view.vue'
import ReportsView from '../views/reports-view.vue'

import auth from '../auth/auth-routes.mjs'
import { useSbuserStore } from '@/auth/sbuser-store.mjs'

import EntryPoint from '../views/entry-point.vue'
import { useSbappStore } from '@/store/sbapp-store.mjs'


/** Global navigation guard to check user meets entry conditions */
function checkEntryConditions(to, _from){
   const sbapp = useSbappStore()
   if (sbapp.entryOk) return true
   else if(to.name=="entrypoint") return true
   else return {name: 'entrypoint', params: {destination: to.fullPath}}
}


const publicRouteNames = [
   auth.LoginFormRoute.name,
   auth.LoginCodeRoute.name,
   'home', 'about', 'entrypoint'
]

/** Navigation guard to redirect non-public pages to login page if not logged in
 */
async function forceLogin(to){
   const sbuser = useSbuserStore();
   if(sbuser.isLoggedIn) return true
   if(publicRouteNames.includes(to.name)) return true
   else return auth.LoginFormRoute.path
}

const routes = [
   {
      // Entry Point
      name: 'entrypoint',
      path: '/entrypoint/:destination(.*)?',
      props: true,
      component: EntryPoint,
   },
   
   auth.LoginFormRoute,
   auth.LoginCodeRoute, 
   
   {
      // Root page goes to Home when logged in, or login page if not
      path: '/',
      redirect(_to){
         const sbuser = useSbuserStore();
         if(sbuser.isLoggedIn) return {path:'/news'}
         else return {path:'/login'}
      }
   },

    {
      // Home page
      name: 'home',
      path: '/news',
      component: HomeView,
   },

   {
      // School datafeed statuses
      name: 'statuses',
      path: '/statuses',
      component: StatusesView,
   },

   {
      // School exclusions counts
      name: 'exclusions',
      path: '/exclusions',
      component: ExcCountsView,
   },

   {
      // Analyse data and download reports
      name: 'reports',
      path: '/reports',
      component: ReportsView,
   },


   /*{
      // Placeholder
      name: 'empty',
      path: '/empty/:id?',
      component: EmptyView,
   },*/

   {
      name: 'about',
      path: '/about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
         import ( /* webpackChunkName: "about" */ '../views/empty-view.vue')
   },

   {
      // If route is unrecognised
      name: 'not-found',
      path: '/:invalidRoute(.*)',
      redirect: '/',
   },
]

const router = createRouter({
   history: createWebHashHistory(),
   routes
})

router.beforeEach(checkEntryConditions)
router.beforeEach(forceLogin)


export default router
